import React from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const DocumentPreviewModal = ({
  isOpen,
  handleClose,
  selectedDoc,
  content,
}) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  if (!isOpen) return null;

  return (
    <div className="documents-modal-overlay">
      <div className="documents-modal-content">
        <div className="documents-modal-header">
          <h4>Document Preview</h4>
          <button onClick={handleClose} className="bg-transparent">
            <i className="bi bi-x-circle"></i>
          </button>
        </div>
        <div className="documents-modal-body">
          {selectedDoc?.file_name?.toLowerCase().endsWith(".pdf") ? (
            <div className="pdf-viewer-container">
              <div className="pdf-wrapper">
                <Worker
                  workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}
                >
                  <Viewer
                    fileUrl={selectedDoc.sign_file_path}
                    plugins={[defaultLayoutPluginInstance]}
                  />
                </Worker>
              </div>
            </div>
          ) : selectedDoc?.file_name?.toLowerCase().endsWith(".docx") ? (
            <div
              className="docx-content"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          ) : [".jpg", ".jpeg", ".png", ".webp"].some((ext) =>
              selectedDoc?.file_name?.toLowerCase().endsWith(ext)
            ) ? (
            <div className="image-preview text-center">
              <img
                src={selectedDoc.sign_file_path}
                alt={selectedDoc.file_name}
                style={{
                  maxWidth: "100%",
                  maxHeight: "80vh",
                  objectFit: "contain",
                }}
              />
            </div>
          ) : (
            <div className="text-center">
              <p>Preview not available for this file type.</p>
              <a
                href={selectedDoc?.sign_file_path}
                target="_blank"
                rel="noopener noreferrer"
                className="download-btn"
              >
                Download File
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DocumentPreviewModal;
